import { User } from '../user/user';

document.addEventListener('DOMContentLoaded', () => {
    const userInstance = new User();
    //userInstance.deleteUser();
});